<script>
  export let year;
  export let even;
</script>

<h1 class="year {even == true ? 'even' : 'odd'}">
  {year}
  <slot />
</h1>

<style>
  .year {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.3;
    transition: opacity 400ms ease;
    font-family: var(--font-small);
    font-weight: 400;
    letter-spacing: 0.64px;
    font-size: 1.5rem;
    -moz-user-select: none;
    -webkit-user-select: none;
    pointer-events: none;
  }

  .year:not(.range) {
    transform: rotate(-90deg) translateX(-50%);
    transform-origin: 0;
  }

  .even {
    bottom: 53%;
  }

  .odd {
    top: 53%;
  }

  :global(.swiper-slide-active .slide:not(.empty) .year) {
    opacity: 1;
  }

  :global(.need-extra-height .year.even) {
    bottom: 83%;
  }

  :global(.need-extra-height .year.odd) {
    top: 83%;
  }

  /* For 'empty' triangles that have a range of years that are missing */
  :global(.swiper-slide-active .range.year) {
    opacity: 1;
  }

  :global(.swiper-slide-active .range.year:before, .swiper-slide-active
      .range.year:after) {
    width: 80px;
  }

  /* MOBILE */
  @media screen and (max-width: 767px) {
    .year {
      transform: translateX(-50%) !important;
    }

    .year.even {
      bottom: 80%;
    }

    .year.odd {
      top: 80%;
    }
  }
</style>
